/**
 * Platform Admin Header Component
 * 
 * Header specifically for platform admin dashboard
 * Does NOT include TenantSwitcher since platform admins don't have tenant context
 */

import { useDispatch } from 'react-redux'
import {
  CContainer,
  CHeader,
  CHeaderBrand,
  CHeaderNav,
  CHeaderToggler,
  CBadge,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import {
  cilMenu,
  cilShieldAlt,
} from '@coreui/icons'

import { AppBreadcrumb } from './index'
import { AppHeaderDropdown } from './index'
import { toggleSidebarShow } from '../../store/slices/uiSlice'

const PlatformAdminHeader = () => {
  const dispatch = useDispatch()

  return (
    <CHeader position="sticky" className="mb-2 header-custom ">
      <CContainer fluid >
        <div className="d-flex align-items-center flex-grow-1 ">
          <CHeaderToggler
            className="header-toggler"
            onClick={() => dispatch(toggleSidebarShow())}
          >
            <CIcon icon={cilMenu} size="lg" />
          </CHeaderToggler>
          
          <CHeaderBrand className="mx-auto d-md-none" to="/">
            <div className="fw-semibold">EDUNA Admin</div>
          </CHeaderBrand>
          
          {/* Platform Admin Badge */}
          <div className="d-none d-md-flex align-items-center ms-3">
            <CIcon icon={cilShieldAlt} size="lg" className="text-danger me-2" />
            <CBadge color="danger" shape="rounded-pill">Platform Admin</CBadge>
          </div>
          
          {/* Breadcrumbs */}
          <div className="d-none d-md-block ms-3 flex-grow-1">
            <AppBreadcrumb />
          </div>
        </div>
        
        <CHeaderNav>
          {/* <CNavItem>
            <CNavLink href="#" title="Notifications">
              <CIcon icon={cilBell} size="lg" />
            </CNavLink>
          </CNavItem>
          <CNavItem>
            <CNavLink href="#" title="Settings">
              <CIcon icon={cilSettings} size="lg" />
            </CNavLink>
          </CNavItem> */}
        </CHeaderNav> 
        <CHeaderNav className="ms-3">
          <AppHeaderDropdown />
        </CHeaderNav>
      </CContainer>
    </CHeader>
  )
}

export default PlatformAdminHeader
